type ABTestingServer = {
  getVariation(campaignName: string): string
  getAllCampaigns(): { [key: string]: string }
}

const campaigns: { [key: string]: string } = {
  'subscriptions-sign-up-component': 'VariantB',
  'loyalty-plus-in-basket-redesign-v2': 'Not bucketed',
  'mnpg-price-trial': 'Not bucketed',
  'customer-google-one-tap': 'Not bucketed',
  'explore-editable-card-content': 'Not bucketed',
}
export const getABTestingServer = (): ABTestingServer => {
  return {
    getVariation: (campaignName: string) => campaigns[campaignName],
    getAllCampaigns: () => campaigns,
  }
}
